import { ApplicationConfig, LOCALE_ID, importProvidersFrom } from '@angular/core';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import { getAuth, provideAuth } from '@angular/fire/auth';
import { environment } from '../environments/environment';
import { NgxPermissionsModule } from 'ngx-permissions';
import { MAT_DATE_LOCALE, provideNativeDateAdapter } from '@angular/material/core';
import { provideZoneChangeDetection } from '@angular/core';
import { AngularFireModule } from '@angular/fire/compat';
import { SETTINGS as FIRESTORE_COMPAT_SETTINGS } from '@angular/fire/compat/firestore';
import { provideHttpClient } from '@angular/common/http';
import { ButacoPreset } from '../assets/styles/ButacoPreset';
import { getFirestore, provideFirestore } from '@angular/fire/firestore';
import { initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { DialogService } from 'primeng/dynamicdialog';
import { MessageService } from 'primeng/api';
import { FlotaVehiculosService } from './pages/05-rrhh/shared/services/flota-vehiculos.service';
import { RrhhAccessService } from './pages/05-rrhh/services/rrhh-access.service';
import { RrhhPermissionsService } from './pages/05-rrhh/services/rrhh-permissions.service';
import { RrhhSessionService } from './pages/05-rrhh/services/rrhh-session.service';
// Import locale data
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es-AR';

// Register locale data
registerLocaleData(localeEs);

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    importProvidersFrom(AngularFireModule.initializeApp(environment.firebase)),
    provideFirebaseApp(() => initializeApp(environment.firebase)),
    provideFirestore(() => getFirestore()),
    // Drop `undefined` fields instead of throwing on set()/update(). Prevents a
    // partial "husk" user object from aborting a save mid-way (SPEC-2026-001).
    { provide: FIRESTORE_COMPAT_SETTINGS, useValue: { ignoreUndefinedProperties: true } },
    provideAnimationsAsync(),
    provideAuth(() => getAuth()),
    provideHttpClient(),
    importProvidersFrom(NgxPermissionsModule.forRoot()),
    { provide: LOCALE_ID, useValue: 'es-AR' },
    { provide: MAT_DATE_LOCALE, useValue: 'es-AR' },
    provideNativeDateAdapter(),
    providePrimeNG({ 
      theme: {
          preset: ButacoPreset
      }
    }),
    DialogService,
    MessageService,
    RrhhPermissionsService,
    RrhhAccessService,
    RrhhSessionService,
    FlotaVehiculosService
  ]
};